<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Stores
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	// Components
	import Icon from '@/Components/Icon.svelte';

	export let selectedRaceId;
	export let selectedMeetingId;
</script>

<div class="flex p-2">
	{#each $RaceStore.where('meeting_id', selectedMeetingId).sortBy('race_number').all() as race (race.id)}
		<button
			on:click={() => navigate(`/racing/meetings/${selectedMeetingId}/races/${race.id}`)}
			class:bg-orange-300={race.id === selectedRaceId}
			class:font-bold={race.id === selectedRaceId}
			class="flex flex-row items-center justify-center px-4 py-2 mx-1 border hover:bg-gray-200 focus:outline-none {!race.visible
				? 'opacity-50'
				: ''}"
		>
			R{race.race_number}
			{#if !race.visible}
				<Icon name="hide" classes="w-4 h-4 ml-0.5" />
			{/if}
		</button>
	{/each}
</div>
